import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the components
ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Tooltip, Legend);

const RankingChart = () => {
  const rankingData = {
    labels: [
      'Election 2013', 'Dec 2016', 'Jan 2017', 'Feb 2017', 
      'Mar 2017', 'Apr 2017', 'May 2017', 'Jun 2017', 
      'Jul 2017', 'Aug 2017'
    ],
    datasets: [
      {
        label: 'CDU',
        data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        borderColor: 'purple',
        fill: false,
      },
      {
        label: 'SPD',
        data: [2, 2, 2, 2, 5, 2, 2, 2, 2, 2],
        borderColor: 'blue',
        fill: false,
      },
      {
        label: 'FDP',
        data: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
        borderColor: 'yellow',
        fill: false,
      },
      {
        label: 'Linke',
        data: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
        borderColor: 'orange',
        fill: false,
      },
      {
        label: 'AfD',
        data: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
        borderColor: 'red',
        fill: false,
      },
      {
        label: 'Grüne',
        data: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
        borderColor: 'green',
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Date',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Rank',
        },
        reverse: true, // Reverse the y-axis to show rank 1 at the top
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };

  return (
    <div>
      <h2>Party Rankings Over Time</h2>
      <Line data={rankingData} options={options} />
    </div>
  );
};

export default RankingChart;